export const customSelectStyles = {
    option: (provided, state) => ({
        ...provided,
        textTransform: "capitalize"
    }),
    control: provided => ({
        ...provided,
        marginTop: "0%",
        textTransform: "capitalize"
    })
};



// WEBPACK FOOTER //
// ./src/components/ThemeComponents/selectStyles.jsx